// @ts-nocheck

/**
 * saw-product-form - Variant selection & subscription (selling plan) or one-time add to cart
 */

(function() {
  u_FormatMoney = (cents, format = '${{amount}}') => {
    if (typeof cents == 'string') cents = cents.replace('.', '');
    var v = '', r = /\{\{\s*(\w+)\s*\}\}/, f = format || this.money_format;
    var d = (o, def) => (typeof o == 'undefined' ? def : o);
    var fm = (n, p, t, dec) => {
      p = d(p, 2); t = d(t, ','); dec = d(dec, '.');
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(p);
      var x = n.split('.'), $ = x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t), c = x[1] ? dec + x[1] : '';
      return $ + c;
    };
    var m = f.match(r);
    if (m) switch (m[1]) {
      case 'amount': v = fm(cents, 2); break;
      case 'amount_no_decimals': v = fm(cents, 0); break;
      case 'amount_with_comma_separator': v = fm(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fm(cents, 0, '.', ','); break;
    }
    return f.replace(r, v);
  };
  
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductCustomWidget', () => ({
      form_id: '',
      product: null,
      currentVariant: null,
      sellingPlanId: null,
      subscriptionType: 'subscribe',
      init() {
        this.product = JSON.parse(this.$el.dataset.product);
        this.currentVariant = JSON.parse(this.$el.dataset.currentVariant);
        this.sellingPlanId = this.u_GetDefaultSellingPlanId();

        this.SetProductFormVariables();
        this.$watch('subscriptionType', this.SetProductFormVariables.bind(this));

        // get form id from data attribute
        let $addtocart = this.$el.closest('.product-details').querySelector('.shopify-product-form');
        if ($addtocart) this.form_id = $addtocart.getAttribute('id');

        this.$nextTick(() => {
          requestAnimationFrame(() => this.u_ScrollQuantityRowToSelected());
        });
      },

      u_ScrollQuantityRowToSelected() {
        if (!window.matchMedia('(max-width: 990px)').matches) return;
        let row = this.$el.querySelector('.saw-variant-option--quantity-cards .saw-variant-options');
        if (!row || row.scrollWidth <= row.clientWidth) return;
        let input = row.querySelector('input[type="radio"]:checked');
        if (!input) return;
        let item = input.closest('option-value');
        if (!item) return;
        item.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
      },
      get isSubscription() {
        return this.subscriptionType === 'subscribe';
      },
      get ProductSellingPlans() {
        return this.product.selling_plan_groups[0].selling_plans;
      },
      get CurrentVariantSellingPlans() {
        let selling_plans = this.currentVariant.selling_plan_allocations.map(item => {
          let plan = this.ProductSellingPlans.find(plan => plan.id == item.selling_plan_id);
          if (!plan) return null;
          plan.name = plan.name.trim();
          return { ...item, ...plan };
        }).filter(plan => plan !== null);
        return selling_plans;
      },
      get SelectedSellingPlan() {
        return this.CurrentVariantSellingPlans.find(plan => plan.id == this.sellingPlanId);
      },
      get isSubscription() {
        return this.subscriptionType === 'subscribe';
      },
      get BoxSize() {
        let box_size = 1;
        if (this.currentVariant.title.toLowerCase().includes('1 box')) {
          box_size = 1;
        }
        else if (this.currentVariant.title.toLowerCase().includes('2 boxes')) {
          box_size = 2;
        }
        else if (this.currentVariant.title.toLowerCase().includes('3 boxes')) {
          box_size = 3;
        }
        return box_size;
      },

      get FooterPriceCents() {
        if (!this.currentVariant) return 0;
        if (this.isSubscription && this.SelectedSellingPlan) return this.SelectedSellingPlan.price;
        if (this.isSubscription) {
          let a = this.currentVariant.selling_plan_allocations;
          return a && a.length ? a[0].price : this.currentVariant.price;
        }
        return this.currentVariant.price;
      },

      get FooterBundleSavings() {
        let oneBox = this.product.variants.find(v => v.title && v.title.includes('1 Box'));
        if (!oneBox || !this.currentVariant) return 0;
        let qty = this.BoxSize;
        if (qty < 1) return 0;
        if (this.isSubscription) {
          let plan = this.SelectedSellingPlan;
          if (!plan) return 0;
          return Math.max(0, oneBox.price * qty - plan.price);
        }
        let unitPrice = this.currentVariant.price / qty;
        return Math.max(0, Math.floor(oneBox.price - unitPrice) * qty);
      },

      u_GetDefaultSellingPlanId() {
        let plans = this.CurrentVariantSellingPlans;
        if (!plans.length) return null;

        let oneMonthPlan = plans.find(plan => /(^|\b)1\s*month(s)?\b/i.test(plan.name || ''));
        return oneMonthPlan ? oneMonthPlan.id : plans[0].id;
      },

      get ImagesByVariant() {
        let media = this.product.media;
        let media_by_variant = media.filter(media => {
          if (!media.alt) {
            media.alt = '';
            return true;
          }
          let media_type = media.alt.split('|||')[0];
          let media_variant_sku = media_type.split('--')[1];
          if (!media_type || !media_variant_sku || !this.currentVariant.sku) return false;
          return !!media_type && media_type.includes('variant') && media_variant_sku.includes(this.currentVariant.sku);
        });
        let media_lifestyle = media.filter(media => {
          let media_type = media.alt.split('|||')[0];
          if (!media_type) return false;
          return media_type.includes('lifestyle');
        });
        let images = [...media_by_variant, ...media_lifestyle];
        return images;
      },

      e_UpdateSelectedVariant(e) {
        let options = e.currentTarget.querySelectorAll('.saw-variant-options input[type="radio"]');
        let selectedValues = Array.from(options).filter(option => option.checked).map(option => option.value);
        let selectedVariant = this.product.variants.find(variant => variant.options.join('/') == selectedValues.join('/'));
        
        // if variant undefined (due to missing combination)
        if (!selectedVariant) {
          // find the first variant that has the same options as the selected values
          let lastSelected = e.target.value;
          selectedVariant = this.product.variants.find(variant => variant.options.includes(lastSelected));
        }
        // console.log(selectedVariant);

        this.currentVariant = selectedVariant;
        this.sellingPlanId = this.u_GetDefaultSellingPlanId();
        this.u_UpdateUrlHistoryVariant();
        // also dispatch a custom event to indicate variant has changed
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: this.currentVariant }
        }));
        this.variantImages = this.ImagesByVariant;

        this.SetProductFormVariables();
      },


      SetProductFormVariables() {
        let $product = this.$el.closest('.product-details');
        let $name_id = $product.querySelector('[name="id"]');
        if ($name_id) $name_id.value = this.currentVariant.id;

        let $selling_plan = $product.querySelector('[name="selling_plan"]');
        if (this.isSubscription) {
          if ($selling_plan) {
            $selling_plan.value = this.sellingPlanId;
          }
          else {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.value = this.sellingPlanId;
            $product.appendChild(input);
          }
        }
        else {
          if ($selling_plan) $selling_plan.remove();
        }
      },

      u_UpdateUrlHistoryVariant() {
        let isProductPage = window.location.pathname.includes('/products/');
        if (!isProductPage) return;
        history.pushState(null, '', `/products/${this.product.handle}?variant=${this.currentVariant.id}`);
      },

      u_FormatMoney(cents) {
        return u_FormatMoney(cents);
      },

      u_GetLeadingVariants(option_position, value) {
        let leadingVariants = []
        if (option_position == 1) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == value);
        }
        else if (option_position == 2) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == this.currentVariant.option1 && variant.option2 == value);
        }
        else if (option_position == 3) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == this.currentVariant.option1 && variant.option2 == this.currentVariant.option2 && variant.option3 == value);
        }
        // console.log(option_position, value, leadingVariants);
        return leadingVariants;
      }
    }));

    Alpine.data('BundleBuilder', (config) => ({
      config: {
        variants: [],
        bundleVariantId: config.bundleVariantId,
        bundleSellingPlanId: config.bundleSellingPlanId,
        bundleSellingPlans: config.bundleSellingPlans ?? [],
        progressPriceSuffix: config.progressPriceSuffix ?? ''
      },
      selected: {
        variants: [],
        purchaseType: 'subscribe',
        frequencyKey: ''
      },
      isAddingToCart: false,
      isStickyAtcVisible: false,
      _stickyAtcObserver: null,
      _stickyAtcMqHandler: null,
      get purchaseType() {
        return this.selected.purchaseType;
      },
      set purchaseType(value) {
        this.selected.purchaseType = value;
      },
      get frequencyKey() {
        return this.selected.frequencyKey;
      },
      set frequencyKey(value) {
        this.selected.frequencyKey = value;
      },
      normalizeFrequencyKey(key) {
        return String(key ?? '').trim().toLowerCase();
      },
      getSellingPlanForVariant(variant, frequencyKey) {
        if (!variant || !frequencyKey) return null;
        const plans = variant.selling_plans ?? [];
        const exact = plans.find(plan => plan.frequency_key === frequencyKey);
        if (exact) return exact;
        const normalized = this.normalizeFrequencyKey(frequencyKey);
        return plans.find(plan => this.normalizeFrequencyKey(plan.frequency_key) === normalized) ?? null;
      },
      getBundleParentSellingPlan(frequencyKey) {
        if (!frequencyKey) return null;
        const plans = this.config.bundleSellingPlans ?? [];
        const exact = plans.find(plan => plan.frequency_key === frequencyKey);
        if (exact) return exact;
        const normalized = this.normalizeFrequencyKey(frequencyKey);
        return plans.find(plan => this.normalizeFrequencyKey(plan.frequency_key) === normalized) ?? null;
      },
      getSubscribePriceCents(variant) {
        if (!variant) return 0;
        const plan = this.getSellingPlanForVariant(variant, this.frequencyKey);
        return Number(plan?.subscribe_price_cents ?? variant.one_time_price_cents ?? 0);
      },
      get frequencyOptions() {
        return (this.config.bundleSellingPlans ?? [])
          .filter(plan => plan?.frequency_key)
          .map(plan => {
            const key = plan.label ?? plan.frequency_key;
            return { value: plan.frequency_key, label: `Every ${key}` };
          });
      },
      get activeBundleSellingPlanId() {
        return this.getBundleParentSellingPlan(this.frequencyKey)?.id ?? null;
      },
      get TotalQuantity() {
        return this.selected.variants.reduce((total, variant) => total + variant.quantity, 0);
      },
      get PackQuantityForPricing() {
        return this.TotalQuantity > 0 ? this.TotalQuantity : 1;
      },
      formatMoney(value) {
        return Number(value).toFixed(2);
      },
      getDefaultPricingVariant() {
        const variants = this.config.variants ?? [];
        return variants.find(v => v?.available) ?? variants[0] ?? null;
      },
      volumeDiscountMultiplier(packQuantity) {
        const qty = Number(packQuantity) || 1;
        if (qty >= 4) return 0.85;
        if (qty === 3) return 0.9;
        return 1;
      },
      projectedTotalForPackQuantity(packQuantity) {
        const targetPackQuantity = Number(packQuantity) > 0 ? Number(packQuantity) : 1;
        const activePackQuantity = this.PackQuantityForPricing;
        let activeTotal = this.purchaseType === 'subscribe'
          ? this.SubscribeTotalPriceValue
          : this.OneTimeTotalPriceValue;
        
        // Fallback: use first available config variant's price when nothing selected
        if (activeTotal === 0) {
          const defaultVariant = this.getDefaultPricingVariant();
          if (defaultVariant) {
            const priceCents = this.purchaseType === 'subscribe'
              ? this.getSubscribePriceCents(defaultVariant)
              : (defaultVariant.one_time_price_cents ?? 0);
            activeTotal = priceCents / 100;
          }
        }
        
        return activePackQuantity > 0
          ? (activeTotal / activePackQuantity) * targetPackQuantity
          : activeTotal;
      },
      get SubscribeTotalPriceValue() {
        let variants = this.selected.variants;
        // If variants are not initialized yet, keep pricing stable at 0.
        if (!variants.length) {
          const defaultVariant = this.getDefaultPricingVariant();
          variants = defaultVariant ? [defaultVariant] : [];
        }
        const totalCents = variants.reduce((sum, variant) => {
          if (!variant) return sum;
          const cents = this.getSubscribePriceCents(variant);
          const qty = Number(variant.quantity ?? 0) || 1;
          return sum + (cents * qty);
        }, 0);
        return totalCents / 100;
      },
      get OneTimeTotalPriceValue() {
        let variants = this.selected.variants;
        // If variants are not initialized yet, keep pricing stable at 0.
        if (!variants.length) {
          const defaultVariant = this.getDefaultPricingVariant();
          variants = defaultVariant ? [defaultVariant] : [];
        }
        const totalCents = variants.reduce((sum, variant) => {
          if (!variant) return sum;
          const cents = Number(variant.one_time_price_cents ?? 0);
          const qty = Number(variant.quantity ?? 0) || 1;
          return sum + (cents * qty);
        }, 0);
        return totalCents / 100;
      },
      get SubscribeUnitPrice() {
        const base = this.SubscribeTotalPriceValue / this.PackQuantityForPricing;
        return this.formatMoney(base * this.volumeDiscountMultiplier(this.PackQuantityForPricing));
      },
      get OneTimeUnitPrice() {
        const base = this.OneTimeTotalPriceValue / this.PackQuantityForPricing;
        return this.formatMoney(base * this.volumeDiscountMultiplier(this.PackQuantityForPricing));
      },
      progressPricePerPack(packQuantity) {
        const targetPackQuantity = Number(packQuantity) > 0 ? Number(packQuantity) : 1;
        const projectedTotal = this.projectedTotalForPackQuantity(targetPackQuantity);
        const base = projectedTotal / targetPackQuantity;
        return this.formatMoney(base * this.volumeDiscountMultiplier(targetPackQuantity));
      },
      progressPricePerPackLabel(packQuantity) {
        return '$' + this.progressPricePerPack(packQuantity) + (this.config.progressPriceSuffix ?? '');
      },
      progressTotalForPack(packQuantity) {
        const targetPackQuantity = Number(packQuantity) > 0 ? Number(packQuantity) : 1;
        const projectedTotal = this.projectedTotalForPackQuantity(targetPackQuantity);
        return this.formatMoney(projectedTotal * this.volumeDiscountMultiplier(targetPackQuantity));
      },
      get TotalActivePrice() {
        const total = this.purchaseType === 'subscribe'
          ? this.SubscribeTotalPriceValue
          : this.OneTimeTotalPriceValue;
        return this.formatMoney(total * this.volumeDiscountMultiplier(this.PackQuantityForPricing));
      },
      get TotalComparePrice() {
        return this.formatMoney(this.OneTimeTotalPriceValue);
      },
      get ShowTotalComparePrice() {
        return Number(this.TotalComparePrice) > Number(this.TotalActivePrice);
      },
      get BundleGuid() {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        });
      },
      init() {
        const defaultPlan = (this.config.bundleSellingPlans ?? []).find(
          plan => plan.id == this.config.bundleSellingPlanId
        );
        if (defaultPlan?.frequency_key) {
          this.frequencyKey = defaultPlan.frequency_key;
        } else if ((this.config.bundleSellingPlans ?? [])[0]?.frequency_key) {
          this.frequencyKey = this.config.bundleSellingPlans[0].frequency_key;
        }

        this.$nextTick(() => this.initStickyAtc());
      },
      /**
       * Keeps the sticky ATC bar visible on mobile for the full scroll.
       */
      initStickyAtc() {
        const mobileQuery = window.matchMedia('(max-width: 749px)');

        const syncVisibility = () => {
          this.isStickyAtcVisible = mobileQuery.matches;
        };

        syncVisibility();

        if (this._stickyAtcMqHandler) {
          mobileQuery.removeEventListener('change', this._stickyAtcMqHandler);
        }

        this._stickyAtcMqHandler = syncVisibility;
        mobileQuery.addEventListener('change', syncVisibility);
      },
      destroy() {
        if (this._stickyAtcObserver) {
          this._stickyAtcObserver.disconnect();
          this._stickyAtcObserver = null;
        }
        if (this._stickyAtcMqHandler) {
          window.matchMedia('(max-width: 749px)').removeEventListener('change', this._stickyAtcMqHandler);
          this._stickyAtcMqHandler = null;
        }
      },
      e_InitBundleVariant(variant) {
        this.config.variants.push(variant);

        if (!this.frequencyKey) {
          const defaultPlan = (this.config.bundleSellingPlans ?? []).find(
            plan => plan.id == this.config.bundleSellingPlanId
          );
          if (defaultPlan?.frequency_key) {
            this.frequencyKey = defaultPlan.frequency_key;
          } else if ((this.config.bundleSellingPlans ?? [])[0]?.frequency_key) {
            this.frequencyKey = this.config.bundleSellingPlans[0].frequency_key;
          }
        }
      },
      e_BundleUpdated(variant) {
        let existing = this.selected.variants.find(v => v.id == variant.id);
        if (existing) {
          Object.assign(existing, variant);
        } else {
          this.selected.variants.push(variant);
        }
        this.selected.variants = [...this.selected.variants.filter(v => v.quantity > 0)];
      },
      clearBundleSelections() {
        this.config.variants.forEach((variant) => {
          if (!variant) return;
          variant.quantity = 0;
        });

        this.selected.variants = [];
      },
      async e_AddBundleToCart() {
        if (this.isAddingToCart) return;

        const bundleId = this.BundleGuid;
        const bundleMin = '2';
        const bundleMax = '5';

        let lines = this.selected.variants
          .filter(variant => Number(variant.quantity) > 0 && Number(variant.id) > 0)
          .map(variant => {
            const line = {
              id: Number(variant.id),
              quantity: Number(variant.quantity) || 1,
              properties: {
                _bundle_id: bundleId,
              }
            };

            if (this.purchaseType === 'subscribe') {
              const plan = this.getSellingPlanForVariant(variant, this.frequencyKey);
              if (plan?.id) line.selling_plan = Number(plan.id);
            }

            return line;
          });

        let bundleParentLine = {
          id: Number(this.config.bundleVariantId),
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_parent: true,
            _bundle_min: bundleMin,
            _bundle_max: bundleMax,
          }
        };

        if (this.purchaseType === 'subscribe') {
          const parentPlanId = this.activeBundleSellingPlanId;
          if (parentPlanId) bundleParentLine.selling_plan = Number(parentPlanId);
        }

        lines.unshift(bundleParentLine);

        if (!lines.length) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: 'bundle-builder',
              data: {
                didError: true,
                source: 'custom-bundle',
                message: 'No bundle items selected'
              }
            }
          }));
          return;
        }

        this.isAddingToCart = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify({ items: lines })
          });
          const resource = await response.json();

          if (!response.ok) {
            throw resource || new Error('Failed to add bundle to cart');
          }

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource,
              sourceId: 'bundle-builder',
              data: {
                didError: false,
                source: 'custom-bundle',
                itemCount: resource && typeof resource.item_count === 'number' ? resource.item_count : undefined
              }
            }
          }));

          this.clearBundleSelections();
        } catch (error) {
          console.error('Error adding bundle to cart:', error);

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: 'bundle-builder',
              data: {
                didError: true,
                source: 'custom-bundle',
                message: error && error.description ? error.description : (error && error.message ? error.message : 'Failed to add bundle to cart')
              }
            }
          }));
        } finally {
          this.isAddingToCart = false;
        }
      }
    }));

    Alpine.data('BundleVariant', (variant) => ({
      variant: variant,
      init() {
        this.InitWatchers();
        this.$dispatch('bundle:init-variant', this.variant);
      },
      InitWatchers() {
        this.$watch('variant', () => {
          // dispatch a custom event to indicate variant has changed
          this.$dispatch('bundle:updated', this.variant);
        });
      }
    }));
  });
})();